/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:18:28
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 11:47:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/Menu/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import TipsAndSwitch from 'src/constrains/SalesChannelPreviewPageComponents/TipsAndSwitch';
import MenuSortableTree from './Components/MenuTree';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getProductMenu,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onProductMenuAdd,
  onProductMenuChange,
} from '../slice';

import { useDispatch } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import Tip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { menuValidation } from '../tools';
const Menu = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const {
    data,
    salesChannelContentUuid,
    specificError,
    isPrimary,
    linkSet,
    disabled,
  } = props;

  const { enabled, roots = [] } = data || {};

  const handleOnEnabledChange = (enabled) => {
    _d(onProductMenuChange({ enabled }));
  };
  const handleOnProductChange = (roots) => {
    _d(onProductMenuChange({ roots }));
  };

  const handleOnProductAdd = (node) => {
    _d(onProductMenuAdd(node));
  };

  return (
    <React.Fragment>
      {isPrimary && (
        <Section bottomBorder>
          <TipsAndSwitch
            enabled={enabled}
            onChange={handleOnEnabledChange}
            title={getI18n('general.hOCTitle.menu')}
            content={getI18n('salesChannelContent.index.createproductmenu')}
          />
        </Section>
      )}
      {/* <Tip tip='Enable menu under primary language' /> */}
      {!isPrimary && !enabled && (
        <Section>
          <Tip
            className={css.tipClassName}
            tip={getI18n('salesChannelContent.index.enablemenu')}
          />
        </Section>
      )}
      {enabled && (
        <MenuSortableTree
          linkSet={linkSet}
          multiLanguageDisabled={!isPrimary}
          onAdd={handleOnProductAdd}
          data={roots}
          errorList={specificError.linkTypeError}
          salesChannelContentUuid={salesChannelContentUuid}
          onChange={handleOnProductChange}
          disableEdit={disabled}
        />
      )}
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(Menu, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.productMenu,
  getContent: getProductMenu,
  title: getI18nFromGeneral('general.hOCTitle.menu'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, _p) => {
    const { isPrimary } = _p;
    return menuValidation(x, isPrimary);
  },
  getSubmitStamp,
});
